import {
  AlertLogsApiGetFiltersRequest,
  AlertLogsApiGetGroupTicketsRequest,
  AlertLogsApiGetTicketsRequest,
  AlertLogsApiSyncAllTicketsRequest,
  AlertLogsApiSyncTicketRequest,
  BulkTicketSyncResponse,
  FilterResponse,
  PaginatedGroupTicketsResponse,
  PaginatedTicketsResponse,
  TicketSyncResponse,
} from '@ariksa/notification/api';
import { call } from 'redux-saga/effects';
import { QueryContext } from 'services/utils/QueryContext';
import { takeLatestAction } from 'services/utils/takeLatestAction';

import {
  AlertVaultTicketService,
  isAlertVaultEnabled,
} from 'api/alert-vault/client';
import { AlertVaultJiraService } from 'api/alert-vault/jira';
import { NotificationService } from 'api/index';

import { actions } from './slice';

export function* ticketSaga() {
  yield takeLatestAction(actions.getTickets, doGetTickets);
  yield takeLatestAction(actions.getChildTickets, doGetTickets);
  yield takeLatestAction(actions.getGroupTickets, doGetGroupTickets);
  yield takeLatestAction(actions.getAssignees, doGetAssignees);
  yield takeLatestAction(actions.getIssueAssignees, doGetAssignees);
  yield takeLatestAction(
    actions.syncTicketInformation,
    doSyncTicketInformation,
  );
  yield takeLatestAction(
    actions.syncAllTicketsInformation,
    doSyncAllTicketsInformation,
  );
}

export function* doGetTickets(
  ctx: QueryContext<PaginatedTicketsResponse, AlertLogsApiGetTicketsRequest>,
) {
  yield call(ctx.fetch, () =>
    isAlertVaultEnabled()
      ? AlertVaultTicketService.list({
          accountId: ctx.params.accountIds?.[0],
          environmentId: ctx.params.environmentId,
          status: ctx.params.state ?? undefined,
          search: ctx.params.search ?? undefined,
          pageNumber: ctx.params.pageNumber,
          pageSize: ctx.params.pageSize,
        })
      : NotificationService.AlertsLogs.getTickets(ctx.params),
  );
}

export function* doGetAssignees(
  ctx: QueryContext<FilterResponse, AlertLogsApiGetFiltersRequest>,
) {
  yield call(ctx.fetch, () =>
    isAlertVaultEnabled()
      ? AlertVaultTicketService.filters()
      : NotificationService.AlertsLogs.getFilters(ctx.params),
  );
}

export function* doGetGroupTickets(
  ctx: QueryContext<
    PaginatedGroupTicketsResponse,
    AlertLogsApiGetGroupTicketsRequest
  >,
) {
  yield call(ctx.fetch, () =>
    isAlertVaultEnabled()
      ? AlertVaultTicketService.list({
          accountId: ctx.params.accountIds?.[0],
          environmentId: ctx.params.environmentId,
          status: ctx.params.state ?? undefined,
          search: ctx.params.search ?? undefined,
          pageNumber: (ctx.params as any).pageNumber,
          pageSize: (ctx.params as any).pageSize,
        })
      : NotificationService.AlertsLogs.getGroupTickets(ctx.params),
  );
}

export function* doSyncTicketInformation(
  ctx: QueryContext<TicketSyncResponse, AlertLogsApiSyncTicketRequest>,
) {
  yield call(ctx.fetch, () =>
    isAlertVaultEnabled()
      ? AlertVaultJiraService.sync(ctx.params.ticketSyncRequest?.ticket_id)
      : NotificationService.AlertsLogs.syncTicket(ctx.params),
  );
}

export function* doSyncAllTicketsInformation(
  ctx: QueryContext<BulkTicketSyncResponse, AlertLogsApiSyncAllTicketsRequest>,
) {
  yield call(ctx.fetch, () =>
    isAlertVaultEnabled()
      ? AlertVaultJiraService.sync(
          undefined,
          ctx.params.allTicketsSyncRequest?.client_id ?? undefined,
        )
      : NotificationService.AlertsLogs.syncAllTickets(ctx.params),
  );
}
